import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { CalendarExtraContentContext } from './Context';
import {
    getDeparturePrices,
    getReturnPrices,
    getCheapestDepartureDays,
    getCheapestReturnDays,
    lastDateRequested,
} from '../../../redux/flexibleDates/selectors';
import { ConnectedFaresProviderRender } from './FaresProviderRender';
import { FaresProviderOnClick } from './FaresProviderOnClick';
import { displayFaresInCalendar } from '../../../redux/currentSearch/selectors';
import { ConnectedFaresProviderRenderDesktop } from './FaresProviderRenderDesktop';

export const FaresProvider =({
    children,
    departurePrices,
    returnPrices,
    cheapestDepartureDays,
    cheapestReturnDays,
    lastDateRequested,
    displayFaresInCalendar,
    desktop,
}) => {
    const cachedFaresProviderOnClick = useCallback( FaresProviderOnClick({ departurePrices, returnPrices,
        cheapestDepartureDays, cheapestReturnDays, lastDateRequested }), [lastDateRequested, departurePrices, returnPrices]);
    const onClick = displayFaresInCalendar ? cachedFaresProviderOnClick : ()=>{};
    const cachedValue = useMemo(() => ({ ExtraContent: desktop ? ConnectedFaresProviderRenderDesktop :
        ConnectedFaresProviderRender, onClick }), [desktop, onClick]);
    return (
        <CalendarExtraContentContext.Provider value={cachedValue}>
            {children}
        </CalendarExtraContentContext.Provider>
    );
};

FaresProvider.propTypes = {
    children: PropTypes.node.isRequired,
    departurePrices: PropTypes.object.isRequired,
    returnPrices: PropTypes.object.isRequired,
    cheapestDepartureDays: PropTypes.array.isRequired,
    cheapestReturnDays: PropTypes.array.isRequired,
    lastDateRequested: PropTypes.number.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
    desktop: PropTypes.bool,
};

FaresProvider.defaultProps = {
    desktop: false,
};

const mapStateToPropsSelector = createStructuredSelector({
    departurePrices: getDeparturePrices,
    returnPrices: getReturnPrices,
    cheapestDepartureDays: getCheapestDepartureDays,
    cheapestReturnDays: getCheapestReturnDays,
    lastDateRequested,
    displayFaresInCalendar,
});

const ConnectedFaresProvider = connect(mapStateToPropsSelector)(FaresProvider);

export { ConnectedFaresProvider };
